/**
 * @file     spacing.ts
 * @readme   ./README.md
 * @purpose  Defines an immutable 12-step spacing scale (0–80px) and a helper function to look up a value by index with safe fallback.
 */
export const spacingTokens = [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80] as const;

export const spacing = (index: number): number => {
  return spacingTokens[index] ?? spacingTokens[spacingTokens.length - 1];
};
